import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id A526C6AC-3E29-49D1-91FA-07F95B470626
 * name menu-up
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/menu-up.svg
 * tags
 * - Arrow 
 */
export const MenuUpIcon = createSvgIcon(<><path d="M7,15L12,10L17,15H7Z" /></>, 'MenuUpIcon');
export default MenuUpIcon